var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11654 1.60944C4.98427 1.60944 1.61816 4.97554 1.61816 9.10782C1.61816 13.2401 4.98427 16.6127 9.11654 16.6127C10.8816 16.6127 12.5048 15.9942 13.7878 14.9672L16.9111 18.0889C17.0688 18.24 17.2793 18.3234 17.4976 18.3211C17.7159 18.3189 17.9247 18.2313 18.0792 18.077C18.2337 17.9227 18.3216 17.7141 18.3242 17.4958C18.3267 17.2775 18.2436 17.0668 18.0928 16.909L14.9694 13.7856C15.9972 12.5007 16.6165 10.8749 16.6165 9.10782C16.6165 4.97554 13.2488 1.60944 9.11654 1.60944ZM9.11654 3.27613C12.3481 3.27613 14.9482 5.87629 14.9482 9.10782C14.9482 12.3393 12.3481 14.946 9.11654 14.946C5.88501 14.946 3.28483 12.3393 3.28483 9.10782C3.28483 5.87629 5.88501 3.27613 9.11654 3.27613Z",
    fill: "#111314"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7bbefdeb9bd89793cd7cab36ac8186f2.svg";
export { ForwardRef as ReactComponent };